import React, { useState } from 'react';
import '../styles/NewsletterSection.css';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setStatus({ type: 'error', message: 'Please enter your email address' });
      return;
    }
    setStatus({ type: '', message: '' });
    try {
      setStatus({ type: '', message: '' });
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json();
        setStatus({ type: 'error', message: data.error || 'Subscription failed. Please try again.' });
        return;
      }
      setStatus({ type: 'success', message: 'Thank you for subscribing!' });
      setEmail('');
    } catch (err) {
      setStatus({ type: 'error', message: 'Network error. Please try again.' });
    }
  };

  return (
    <section className="newsletter-section">
        <div className="newsletter-overlay"></div>
        <div className="newsletter-content">
          <h2>NEWSLETTER</h2>
          <p>Subscribe now to our newsletter.</p>
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input type="email" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)} />
            <button type="submit" disabled={status.type === 'loading'}>SUBSCRIBE NOW</button>
          </form>
          {status.message && (
            <div className={`newsletter-status ${status.type}`}>{status.message}</div>
          )}
        </div>
    </section>
  );
};

export default NewsletterSection; 